<template lang="pug">
	.download-button
		.icon(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Download code'}" v-pseudo-modal-show="'download-dropdown'" v-on:click="$root.$emit('bv::hide::tooltip')")
			.fa.fa-download
		.dropdown-menu.dropdown-menu-right(v-pseudo-modal="'download-dropdown'")
			.dropdown-header.text-center
				strong Download creative
			NetworkList(:callback="downloadCreative" scope="download")
</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Template } 		from '../../services/Template'

	import NetworkList 			from './../Shared/NetworksList'

	export default {
		name: "DownloadButton",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Project Changed"]
		},
		components: {
			NetworkList
		},
		data() {

			this.Template = Template;

			return {
				showed: true
			};

		},
		methods: {
			downloadCreative(type) {

				if (type === 'sky-kids') {

					Broadcast.call("Show Upload Sky Kids", ["download-mode"]);

				} else {

					Server.sendToSocket({
						DownloadCreative: {
							projectId: Project.SelectedProject.id,
							releaseType: type
						}
					});

				}

				Broadcast.call("Pseudo Modal Hide", ['download-dropdown']);

			}
		}
	}
</script>


<style lang="sass">

	.download-button
		list-style: none
		position: relative

		.dropdown-menu
			position: absolute
			left: -230px
			top: 40px
			display: block
			z-index: 10000
			line-height: 1.5
			width: 250px
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)

			.dropdown-header
				cursor: default

			.networks
				height: 197px
				overflow-x: hidden
				overflow-y: auto

				.dropdown-item
					white-space: normal
					padding: 0px 20px 10px 20px
					width: 250px

			.networks::-webkit-scrollbar
				width: 10px
				margin-left: -10px
				-webkit-appearance: none
				appearance: none

			.networks::-webkit-scrollbar-track
				background-color: rgba(255,255,255,0.3)
				border-right: 1px solid #f2f2f2
				border-left: 1px solid #f2f2f2

			.networks::-webkit-scrollbar-thumb
				height: 50px
				background-color: rgba(255,255,255,0.2)
				background-clip: content-box
				border-color: transparent
				border-style: solid
				border-width: 1px 2px

</style>

